import React from 'react';
import { Radio } from 'antd';

interface StyledRadioButtonProps {
  value: 'and' | 'or';
  selectedValue: 'and' | 'or';
  disabled?: boolean;
}

const StyledRadioButton: React.FC<StyledRadioButtonProps> = ({
  value,
  selectedValue,
  disabled,
}) => {
  const isSelected = value === selectedValue;
  const label = value.toUpperCase();

  return (
    <Radio.Button
      value={value}
      disabled={disabled}
      style={{
        backgroundColor: isSelected ? 'rgba(0, 70, 255, 1)' : 'white',
        color: isSelected ? 'white' : 'rgba(0, 70, 255, 1)',
        borderColor: 'rgba(0, 70, 255, 1)',
        fontWeight: isSelected ? '600' : '400',
        fontSize: '12px',
        height: '22px',
        width: '32px',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {label}
    </Radio.Button>
  );
};

interface LogicRadioGroupProps {
  value: 'and' | 'or';
  onChange: (value: 'and' | 'or') => void;
  disabled?: boolean;
  testId?: string;
  size?: 'small' | 'default';
}

export const LogicRadioGroup: React.FC<LogicRadioGroupProps> = ({
  value,
  onChange,
  disabled = false,
  testId,
  size = 'default',
}) => {
  const height = size === 'small' ? '18px' : '22px';

  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ display: 'inline-flex' }}
      disabled={disabled}
      data-test-id={testId}
    >
      <Radio.Button
        value="and"
        disabled={disabled}
        style={{
          backgroundColor: value === 'and' ? 'rgba(0, 70, 255, 1)' : 'white',
          color: value === 'and' ? 'white' : 'rgba(0, 70, 255, 1)',
          borderColor: 'rgba(0, 70, 255, 1)',
          fontWeight: value === 'and' ? '600' : '400',
          fontSize: '12px',
          height,
          width: '32px',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        AND
      </Radio.Button>
      <Radio.Button
        value="or"
        disabled={disabled}
        style={{
          backgroundColor: value === 'or' ? 'rgba(0, 70, 255, 1)' : 'white',
          color: value === 'or' ? 'white' : 'rgba(0, 70, 255, 1)',
          borderColor: 'rgba(0, 70, 255, 1)',
          fontWeight: value === 'or' ? '600' : '400',
          fontSize: '12px',
          height,
          width: '32px',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        OR
      </Radio.Button>
    </Radio.Group>
  );
};

export default StyledRadioButton;
